import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classnames from 'classnames'

import { useWeekPickerStyles } from './styles'

const WeekPicker = ({ disabled, id, label, weekDay, onWeekChange, ...props }) => {
  const handleWeekChange = direction =>
    onWeekChange(
      moment(weekDay)
        [direction === 'prev' ? 'subtract' : 'add'](1, 'weeks')
        .startOf('isoWeek')
    )

  const classes = useWeekPickerStyles()
  return (
    <div className={classes.weekPickerWrapper}>
      {label && <label id={`${id}-label`}>{label}</label>}
      <div
        className={classnames(classes.weekPicker, {
          [classes.weekPickerDisabled]: disabled
        })}
        id={id}
        {...props}
      >
        <div className={classes.arrowWrapper} onClick={() => handleWeekChange('prev')}>
          <i data-arrow="left" />
        </div>
        <div className={classes.label}>
          {`${moment(weekDay)
            .startOf('isoWeek')
            .format('DD. MM.')} - ${moment(weekDay)
            .endOf('isoWeek')
            .format('DD. MM. YYYY')}
          `}
        </div>
        <div className={classes.arrowWrapper} onClick={() => handleWeekChange('next')}>
          <i data-arrow="right" />
        </div>
      </div>
    </div>
  )
}

WeekPicker.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.any,
  label: PropTypes.string,
  weekDay: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
  onWeekChange: PropTypes.func.isRequired
}

export default WeekPicker
